var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5999 12.0365C21.5999 17.3385 17.3018 21.6365 11.9999 21.6365C6.69797 21.6365 2.3999 17.3385 2.3999 12.0365C2.3999 6.73459 6.69797 2.43652 11.9999 2.43652C17.3018 2.43652 21.5999 6.73459 21.5999 12.0365ZM13.1999 16.8365C13.1999 17.4993 12.6626 18.0365 11.9999 18.0365C11.3372 18.0365 10.7999 17.4993 10.7999 16.8365C10.7999 16.1738 11.3372 15.6365 11.9999 15.6365C12.6626 15.6365 13.1999 16.1738 13.1999 16.8365ZM11.9999 6.03652C11.3372 6.03652 10.7999 6.57378 10.7999 7.23652V12.0365C10.7999 12.6993 11.3372 13.2365 11.9999 13.2365C12.6626 13.2365 13.1999 12.6993 13.1999 12.0365V7.23652C13.1999 6.57378 12.6626 6.03652 11.9999 6.03652Z",
    fill: "#E02424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/error-circle.8305474531cb9c93e22a5f06193c8550.svg";
export { ForwardRef as ReactComponent };